<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }}</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <!-- <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div> -->
          <p>
            Course nature, dans le massif des Costes. Parcours assez roulant, beaucoup de single.<br />
            Départ et arrivée av ST ROCH (devant le collège de Pélissanne)<br />
            Ce sera la 40ème édition (beaucoup de surprises) dotation en lot (valeurs 100euros) pour le PODIUM SCRATCH<br />
            CHALLENGE DU NOMBRE et récompense 1er de chaque catégorie F/H
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/20220706_141721.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>
      <h4>Informations à venir...</h4>
      <hr />
      <b-row>
        <b-col>
          <!-- <p><b>Contact : MERVELAY Fabien 06 08 63 33 17</b></p> -->
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <!--   <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/COURSE_146491921.gpx" target="_blank">GPX de l'épreuve</b-button>
          <b-button class="infos_btn" href="https://rondedespontsbleus.msathle.com/" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="http://rondedespontsbleus.msathle.com/blog/" target="_blank">Réglement</b-button>

          <b-button class="infos_btn" href="https://sportips.fr/" target="_blank">Inscriptions</b-button> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>